import { Avatar, styled } from '@mui/material';

export const InitialalsAvatar = styled(Avatar)(() => ({
    width: 24,
    height: 24,
    fontSize: '0.625rem',
    fontWeight: 600,
}));
